import React, { useEffect, useState } from "react";
import Papa from "papaparse";

function Laporan() {
  const [rows, setRows] = useState([]);

  const url =
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vTBNQUhkCR9DHNLlwXsIZKy7lO1_2Jt0KxKEU2BHp7LykkgUK9kQQAqIFqJEoVQ0yv10sKgBckXs7vJ/pub?gid=415788090&single=true&output=csv";

  useEffect(() => {
    fetch(url)
      .then((res) => res.text())
      .then((csvText) => {
        const result = Papa.parse(csvText, { header: true });
        setRows(result.data);
      })
      .catch((err) => console.error("Gagal fetch data:", err));
  }, []);

  if (rows.length === 0) {
    return <p style={{ padding: "20px" }}>⏳ Sedang memuat data laporan...</p>;
  }

  const rekapPerULP = rows.reduce((acc, row) => {
    const ulp = row["ULP"];
    if (!ulp) return acc;

    if (!acc[ulp]) {
      acc[ulp] = {
        unit: row["UNIT"] || "",
        pelanggan: 0,
        sudah: 0,
        belum: 0,
        kodeE: 0,
        kodeI: 0,
        kwhDidalamBangunan: 0,
        kwhTidakAda: 0,
        normal: 0,
        rumahKosong: 0,
        rumahTutup: 0,
        percentase: 0, // Tambahkan properti inisialisasi
      };
    }

    acc[ulp].pelanggan += 1;

    const status = row["KET APK"]?.trim().toLowerCase();
    if (status === "sudah dibaca") acc[ulp].sudah += 1;
    else acc[ulp].belum += 1;

    const kodeACMT = row["KODE ACMT"]?.trim().toLowerCase();
    if (kodeACMT.includes("e") && kodeACMT.includes("rumah tutup")) acc[ulp].kodeE += 1;
    if (kodeACMT.includes("i") && kodeACMT.includes("kwh didalam bangunan")) acc[ulp].kodeI += 1;

    const kondisi = row["KONDISI"]?.trim().toLowerCase();
    if (kondisi === "kwh didalam bangunan") acc[ulp].kwhDidalamBangunan += 1;
    if (kondisi === "kwh tidak ada") acc[ulp].kwhTidakAda += 1;
    if (kondisi === "normal") acc[ulp].normal += 1;
    if (kondisi === "rumah kosong") acc[ulp].rumahKosong += 1;
    if (kondisi === "rumah tutup") acc[ulp].rumahTutup += 1;

    return acc;
  }, {});

  // Hitung persentase untuk setiap ULP setelah reduce selesai
  Object.values(rekapPerULP).forEach(d => {
    d.percentase = ((d.sudah / d.pelanggan) * 100) || 0;
  });

  const total = Object.values(rekapPerULP).reduce(
    (sum, d) => ({
      pelanggan: sum.pelanggan + (d.pelanggan || 0),
      sudah: sum.sudah + (d.sudah || 0),
      belum: sum.belum + (d.belum || 0),
      kodeE: sum.kodeE + (d.kodeE || 0),
      kodeI: sum.kodeI + (d.kodeI || 0),
      kwhDidalamBangunan: sum.kwhDidalamBangunan + (d.kwhDidalamBangunan || 0),
      kwhTidakAda: sum.kwhTidakAda + (d.kwhTidakAda || 0),
      normal: sum.normal + (d.normal || 0),
      rumahKosong: sum.rumahKosong + (d.rumahKosong || 0),
      rumahTutup: sum.rumahTutup + (d.rumahTutup || 0),
      percentase: 0, // Tambahkan properti inisialisasi
    }),
    {
      pelanggan: 0,
      sudah: 0,
      belum: 0,
      kodeE: 0,
      kodeI: 0,
      kwhDidalamBangunan: 0,
      kwhTidakAda: 0,
      normal: 0,
      rumahKosong: 0,
      rumahTutup: 0,
      percentase: 0,
    }
  );

  // Hitung persentase total
  total.percentase = ((total.sudah / total.pelanggan) * 100) || 0;


  const tdCenter = {
    border: "1px solid #999",
    padding: "8px",
    textAlign: "center",
  };

  const tdLeft = {
    border: "1px solid #999",
    padding: "8px",
    textAlign: "left",
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h2 style={{ fontWeight: "bold", marginBottom: "20px" }}>
        📊 Laporan Monitoring Data Pelanggan Kode ACMT
      </h2>

      <table style={{ borderCollapse: "collapse", width: "100%" }}>
        <thead>
          <tr>
            {[
              "NO",
              "UNIT",
              "ULP",
              "Jml Pelanggan",
              "Sudah Dibaca",
              "Belum",
              "Kode E",
              "Kode I",
              "KWH Didalam Bangunan",
              "KWH Tidak Ada",
              "Normal",
              "Rumah Kosong",
              "Rumah Tutup",
              "Percentase", // Header kolom persentase
            ].map((header) => (
              <th
                key={header}
                style={{
                  border: "1px solid #999",
                  backgroundColor: "#f0f0f0",
                  padding: "8px",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Object.entries(rekapPerULP).map(([ulp, data], i) => (
            <tr key={ulp}>
              <td style={tdCenter}>{i + 1}</td>
              <td style={tdCenter}>{data.unit}</td>
              <td style={tdLeft}>{ulp}</td>
              <td style={tdCenter}>{data.pelanggan.toLocaleString()}</td>
              <td style={tdCenter}>{data.sudah.toLocaleString()}</td>
              <td style={tdCenter}>{data.belum.toLocaleString()}</td>
              <td style={tdCenter}>{data.kodeE.toLocaleString()}</td>
              <td style={tdCenter}>{data.kodeI.toLocaleString()}</td>
              <td style={tdCenter}>{data.kwhDidalamBangunan.toLocaleString()}</td>
              <td style={tdCenter}>{data.kwhTidakAda.toLocaleString()}</td>
              <td style={tdCenter}>{data.normal.toLocaleString()}</td>
              <td style={tdCenter}>{data.rumahKosong.toLocaleString()}</td>
              <td style={tdCenter}>{data.rumahTutup.toLocaleString()}</td>
               {/* Data cell persentase */}
              <td style={tdCenter}>
                {data.percentase.toFixed(2)}%
              </td>
            </tr>
          ))}
          <tr style={{ fontWeight: "bold", backgroundColor: "#f9f9f9" }}>
            <td style={tdCenter} colSpan={3}>JUMLAH TOTAL</td>
            <td style={tdCenter}>{total.pelanggan.toLocaleString()}</td>
            <td style={tdCenter}>{total.sudah.toLocaleString()}</td>
            <td style={tdCenter}>{total.belum.toLocaleString()}</td>
            <td style={tdCenter}>{total.kodeE.toLocaleString()}</td>
            <td style={tdCenter}>{total.kodeI.toLocaleString()}</td>
            <td style={tdCenter}>{total.kwhDidalamBangunan.toLocaleString()}</td>
            <td style={tdCenter}>{total.kwhTidakAda.toLocaleString()}</td>
            <td style={tdCenter}>{total.normal.toLocaleString()}</td>
            <td style={tdCenter}>{total.rumahKosong.toLocaleString()}</td>
            <td style={tdCenter}>{total.rumahTutup.toLocaleString()}</td>
             {/* Data cell total persentase */}
            <td style={tdCenter}>
                {total.percentase.toFixed(2)}%
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default Laporan;